import { webHooks } from '@/api'

export default {
  getPattern: ({ commit }) => webHooks.getPattern()
    .then(({ data }) => {
      commit('setPattern', data.data)
    }),
}
